import { TextField } from "@mui/material";
import { useTranslation } from "react-i18next";

export const EmailSubjectInput = (props) => {
    const { value, onChange } = props;
    const { t } = useTranslation();

    return (
        <TextField
            fullWidth
            label={`${t("SendEmailDialog.emailSubject")}*`}
            value={value}
            onChange={(event) => onChange(event.target.value)}
            variant="outlined"
            placeholder={`${t("SendEmailDialog.emailSubjectHelper")}`}
            disabled={props.readOnly}
        />
    );
};
